<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.duration.title' | translate"
  [description]="'organizer.edit.duration.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="formGroup.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="showConfirmBookableUntilTheEndModal()"
  [skipSaveModal]="true"
>
  <form [formGroup]="formGroup" (ngSubmit)="updateDuration()">
    <ng-container *ngIf="isCourseType || isEventType">
      <app-input-counter
        class="mb-6 block"
        formControlName="dayDuration"
        [help]="'organizer.edit.duration.form.day_duration.help' | translate"
        [label]="'organizer.edit.duration.form.day_duration.label' | translate"
        [min]="1"
      ></app-input-counter>

      <app-form-input-group
        class="mb-6 block"
        [label]="
          'organizer.edit.duration.form.course_start_time.label' | translate
        "
      >
        <app-form-input
          #content
          type="time"
          formControlName="courseStartTime"
        ></app-form-input>
      </app-form-input-group>

      <app-form-input-group
        class="mb-6 block"
        [label]="
          'organizer.edit.duration.form.course_end_time.label' | translate
        "
      >
        <app-form-input
          #content
          type="time"
          formControlName="courseEndTime"
        ></app-form-input>
      </app-form-input-group>
    </ng-container>

    <ng-container *ngIf="!isCourseType && !isEventType">
      <app-form-input-group
        [label]="'organizer.edit.duration.form.time_duration.label' | translate"
        [errors]="formGroup.errors"
        errorKey="invalidDuration"
      >
        <app-form-duration formControlName="timeDuration"></app-form-duration>
      </app-form-input-group>
    </ng-container>

    <app-form-checkbox
      formControlName="bookableUntilTheEnd"
      class="block mt-4 mb-4"
      label="{{
        'activity_creation.duration.form.bookable_until_the_end' | translate
      }}"
    ></app-form-checkbox>

    <app-modal
      #confirmBookableUntilTheEndModal
      [role]="modalRole.AlertDialog"
      class="activity-edition-duration-modal"
      [hasCloseButton]="false"
      (modalClose)="closeConfirmBookableUntilTheEndModal()"
    >
      <span modal-header class="text-2xl">
        {{ 'editing_activity.duration_modal.title' | translate }}
      </span>

      <div modal-content>
        <p>{{ 'editing_activity.duration_modal.text_line1' | translate }}</p>
        <p>{{ 'editing_activity.duration_modal.text_line2' | translate }}</p>
      </div>
      <div modal-footer class="flex mb-4 justify-center">
        <button
          class="activity-edition-duration-modal__footer__confirm"
          app-vtmn-play-button
          type="button"
          [type]="ctaButtonType.Button"
          [variant]="vtmnPlayButtonVariant.SECONDARY"
          [shape]="vtmnPlayButtonShape.SQUARED"
          (click)="closeConfirmBookableUntilTheEndModal()"
        >
          {{ 'editing_activity.duration_modal.cancel' | translate }}
        </button>

        <button
          app-vtmn-play-button
          type="button"
          class="ml-3"
          [type]="ctaButtonType.Button"
          [variant]="vtmnPlayButtonVariant.PRIMARY"
          [shape]="vtmnPlayButtonShape.SQUARED"
          (click)="updateDuration()"
        >
          {{ 'editing_activity.duration_modal.confirm' | translate }}
        </button>
      </div>
    </app-modal>
  </form>
</app-organizer-shared-layout-edit-field>
